module.exports={render:function (){var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;
  return (_vm.bannerMsg) ? _c('div', {
    staticClass: "row banner-container",
    style: ([_vm.bannerStyle])
  }, [_c('div', {
    staticClass: "col-sm-12 d-flex justify-content-center align-items-center banner-wrapper",
    class: _vm.callerComp === 'exc-revamp' ? 'pt-2 pb-2' : '',
    style: ({
      textAlign: _vm.bannerStyle.textAlign ? _vm.bannerStyle.textAlign : 'center'
    })
  }, [(_vm.bannerMsg.toLowerCase() && !_vm.bannerMsg.toLowerCase().includes('click here')) ? _c('p', {
    domProps: {
      "innerHTML": _vm._s(_vm.bannerMsg)
    }
  }) : _c('p', _vm._l((_vm.bannerTxtArr), function(text, index) {
    return _c('span', {
      key: index
    }, [(text.toLowerCase() === 'click here') ? _c('a', {
      staticClass: "unl color-inherit",
      attrs: {
        "href": _vm.$parent.$parent && _vm.$parent.$parent.isDesktop ? 'https://play.google.com/store/apps/details?id=com.thesouledstore' : 'https://bit.ly/appxtss'
      },
      on: {
        "click": _vm.triggerEvent
      }
    }, [_vm._v(_vm._s(text))]) : _c('span', [_vm._v(_vm._s(text))])])
  })), _vm._v(" "), (_vm.toggleCashbackPopup) ? _c('img', {
    staticClass: "i-image pointer know-more-icon",
    attrs: {
      "src": "https://tss-static-images.gumlet.io/icons/tssHelpDetails.png"
    },
    on: {
      "click": function($event) {
        _vm.toggleCashbackPopup(true)
      }
    }
  }) : _vm._e()])]) : _vm._e()
},staticRenderFns: []}


//////////////////
// WEBPACK FOOTER
// ./~/vue-loader/lib/template-compiler?{"id":"data-v-4b846c55"}!./~/vue-loader/lib/selector.js?type=template&index=0!./src/components/common/BannerPlaceHolderMsg.vue
// module id = 894
// module chunks = 113